@if (allTasks) {
    <div class="results-table">
    <table mat-table [dataSource]="allTasks" multiTemplateDataRows class="mat-elevation-z8">
        <!-- Task ID Column -->
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>Task ID</th>
            <td mat-cell *matCellDef="let task">{{ task.id }}</td>
        </ng-container>
        <!-- Client ID Column -->
        <ng-container matColumnDef="clientId">
            <th mat-header-cell *matHeaderCellDef>Client ID</th>
            <td mat-cell *matCellDef="let task">{{ task.clientId }}</td>
        </ng-container>
        <!-- Description Column -->
        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let task">{{ task.description }}</td>
        </ng-container>
        <!-- Created Column -->
        <ng-container matColumnDef="created">
            <th mat-header-cell *matHeaderCellDef>Created</th>
            <td mat-cell *matCellDef="let task">{{ task.created | date:'short' }}</td>
        </ng-container>
        <!-- Completed Successfully Column -->
        <ng-container matColumnDef="completedSuccessfully">
            <th mat-header-cell *matHeaderCellDef>Completed?</th>
            <td mat-cell *matCellDef="let task">
                {{ task.completedSuccessfully ? 'Yes' : 'No' }}
            </td>
        </ng-container>
        <!-- Expanded Detail Column -->
        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let task" [attr.colspan]="displayedColumns.length">
                <div class="detail-container">
                    <!-- Basic Info -->
                    <div class="detail-section">
                        <h4>Task Details</h4>
                        <p><strong>Task Type:</strong> {{ task.taskType }}</p>
                        <p><strong>Client ID:</strong> {{ task.clientId }}</p>
                        <p><strong>Description:</strong> {{ task.description }}</p>
                        <p><strong>Created:</strong> {{ task.created | date:'medium' }}</p>
                        <p><strong>Completed Successfully:</strong> {{ task.completedSuccessfully ? 'Yes' : 'No' }}</p>
                        <p><strong>Attempts:</strong> {{ task.attempts }}</p>
                        @if (task.lastAttempt) {
                            <p>
                                <strong>Last Attempt:</strong> {{ task.lastAttempt | date:'medium' }}
                            </p>
                        }
                        @if (task.completed) {
                            <p>
                                <strong>Completed:</strong> {{ task.completed | date:'medium' }}
                            </p>
                        }
                    </div>
                    <!-- Execution & Notifications -->
                    <div class="detail-section">
                        <h4>Execution & Notifications</h4>
                        @if (task.taskExecutionResult) {
                            <div>
                                @for (output of task.taskExecutionResult.outputs; track output) {
                                    @if (output.contentType === 'text/markdown') {
                                        <div [innerHTML]="parseTextOutput(output)"></div>
                                    }
                                    @if (output.contentType === 'application/json') {
                                        <pre>{{ output.content | json }}</pre>
                                    }
                                    @if (output.contentType.indexOf('audio') > -1) {
                                        <audio controls>
                                            <source [src]="parseAudioOutput(output)" type="{{ output.contentType }}">
                                        </audio>
                                    }
                                }
                            </div>
                        }
                        <p>
                            <strong>Email Notifications Enabled:</strong>
                            {{ task.emailNotificationsEnabled ? 'Yes' : 'No' }}
                        </p>
                        @if (task.emailNotificationsEnabled) {
                            <p>
                                <strong>Subject:</strong> {{ task.emailNotificationSubject }}
                            </p>
                        }
                        @if (task.emailNotificationsEnabled && task.emailNotificationRecipients?.length) {
                            <p>
                                <strong>Recipients:</strong> {{ task.emailNotificationRecipients.join(', ') }}
                            </p>
                        }
                    </div>
                    <!-- Additional Data -->
                    <div class="detail-section">
                        <h4>Additional Data</h4>
                        <div [innerHTML]="marked.parse(task.data)"></div>
                        @if (task.updateMessages?.length) {
                            <div>
                                <strong>Update Messages:</strong>
                                <ul>
                                    @for (msg of task.updateMessages; track msg) {
                                        <li>{{ msg }}</li>
                                    }
                                </ul>
                            </div>
                        }
                    </div>
                    <!-- Completion IDs -->
                    <div class="detail-section">
                        <h4>Completion IDs</h4>
                        <p><strong>Originating:</strong> {{ task.originatingCompletionId }}</p>
                        <p><strong>Executing:</strong> {{ task.executingCompletionId }}</p>
                    </div>
                </div>
            </td>
        </ng-container>
        <!-- Header Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <!-- Data Row -->
        <tr mat-row
            *matRowDef="let task; columns: displayedColumns"
            class="element-row"
            (click)="expandedElement = expandedElement === task ? null : task">
        </tr>
        <!-- Detail Row (hidden when not expanded) -->
        <tr mat-row
            *matRowDef="let task; columns: ['expandedDetail']"
            class="detail-row"
            [style.display]="expandedElement === task ? 'table-row' : 'none'">
        </tr>
    </table>
    </div>
}
